module.exports = __webpack_public_path__ + "img/public-qrcode.2ad9b44a.png";